import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  { path: '/', name: 'Home', component: () => import('../pages/HomePage.vue') },
  { path: '/feed', name: 'Feed', component: () => import('../pages/FeedPage.vue')},
  { path: '/inzenden', component: () => import('../pages/InzendenPage.vue'), meta: { requiresAuth: true } },
  { path: '/login', name: 'Login', component: () => import('../pages/LoginPage.vue') },
  { path: '/register', name: 'Register', component: () => import('../pages/RegisterPage.vue') },
  // { path: '/about', component: () => import('./pages/About.vue') },
  // { path: '/contact', component: () => import('./pages/Contact.vue') },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('../pages/404Page.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes // short for `routes: routes`
})

// Navigation guard for protected routes
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters['auth/isAuthenticated']) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router